export default __webpack_public_path__ + "media/images/features/ana/details_sp-f89f3f03929c8ce40268450e2864dfc2.png";